import { createReducer } from 'redux-act';
import actions from '../actions/locationActions';

const initialState = {
  getAllLocationsPending: false,
  getAllLocationsRes: null,
  getAllLocationsError: null,

  createLocationPending: false,
  createLocationRes: null,
  createLocationError: null,

  updateLocationPending: false,
  updateLocationRes: null,
  updateLocationError: null,

  deleteLocationPending: false,
  deleteLocationRes: null,
  deleteLocationError: null,

  getAllLocationsDataPending: false,
  getAllLocationsDataRes: null,
  getAllLocationsDataError: null,

  getAllCountriesListPending: false,
  getAllCountriesListRes: null,
  getAllCountriesListError: null,

  getAllStateFromCountryListPending: false,
  getAllStateFromCountryListRes: null,
  getAllStateFromCountryListError: null,

  getCityListFromStatePending: false,
  getCityListFromStateRes: null,
  getCityListFromStateError: null,

  addEmployeeLocationPending: false,
  addEmployeeLocationRes: null,
  addEmployeeLocationError: null,

  getEmployeeLocationPending: false,
  getEmployeeLocationRes: null,
  getEmployeeLocationError: null,

  updateMultipleEmployeeLocationPending: false,
  updateMultipleEmployeeLocationRes: null,
  updateMultipleEmployeeLocationError: null,

  getAllCityPending: false,
  getAllCityRes: null,
  getAllCityError: null,

  getAllCityFromCountryPending: false,
  getAllCityFromCountryRes: null,
  getAllCityFromCountryError: null,

  getLocationByLetLogPending: false,
  getLocationByLetLogRes: null,
  getLocationByLetLogError: null,

};
/*Get All Location Reducers*/
const handleGetAllLocationsRequest = state => {
  return {
    ...state,
    ...{
      getAllLocationsPending: true,
      getAllLocationsRes: null,
      getAllLocationsError: null,
    },
  };
};
const handleGetAllLocationsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllLocationsPending: false,
      getAllLocationsRes: payload,
      getAllLocationsError: null,
    },
  };
};
const handleGetAllLocationsError = (state, payload) => ({
  ...state,
  ...{
    getAllLocationsPending: false,
    getAllLocationsRes: null,
    getAllLocationsError: payload,
  },
});

/* Create Location Reducers*/
const handleCreateLocationRequest = state => {
  return {
    ...state,
    ...{
      createLocationPending: true,
      createLocationRes: null,
      createLocationError: null,
    },
  };
};
const handleCreateLocationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createLocationPending: false,
      createLocationRes: payload,
      createLocationError: null,
    },
  };
};
const handleCreateLocationError = (state, payload) => ({
  ...state,
  ...{
    createLocationPending: false,
    createLocationRes: null,
    createLocationError: payload,
  },
});


/* Update Location Reducers */
const handleUpdateLocationRequest = state => {
  return {
    ...state,
    ...{
      updateLocationPending: true,
      updateLocationRes: null,
      updateLocationError: null,
    },
  };
};
const handleUpdateLocationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateLocationPending: false,
      updateLocationRes: payload,
      updateLocationError: null,
    },
  };
};
const handleUpdateLocationError = (state, payload) => ({
  ...state,
  ...{
    updateLocationPending: false,
    updateLocationRes: null,
    updateLocationError: payload,
  },
});

/* Delete Location Reducers */
const handleDeleteLocationRequest = state => {
  return {
    ...state,
    ...{
      deleteLocationPending: true,
      deleteLocationRes: null,
      deleteLocationError: null,
    },
  };
};
const handleDeleteLocationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteLocationPending: false,
      deleteLocationRes: payload,
      deleteLocationError: null,
    },
  };
};
const handleDeleteLocationError = (state, payload) => ({
  ...state,
  ...{
    deleteLocationPending: false,
    deleteLocationRes: null,
    deleteLocationError: payload,
  },
});


/* Get All Locations Data Reducers */
const handleGetAllLocationsDataRequest = state => {
  return {
    ...state,
    ...{
      getAllLocationsDataPending: true,
      getAllLocationsDataRes: null,
      getAllLocationsDataError: null,
    },
  };
};
const handleGetAllLocationsDataSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllLocationsDataPending: false,
      getAllLocationsDataRes: payload,
      getAllLocationsDataError: null,
    },
  };
};
const handleGetAllLocationsDataError = (state, payload) => ({
  ...state,
  ...{
    getAllLocationsDataPending: false,
    getAllLocationsDataRes: null,
    getAllLocationsDataError: payload,
  },
});


/* Get All  Countries List Reducers */
const handleGetAllCountriesListRequest = state => {
  return {
    ...state,
    ...{
      getAllCountriesListPending: true,
      getAllCountriesListRes: null,
      getAllCountriesListError: null,
    },
  };
};
const handleGetAllCountriesListSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllCountriesListPending: false,
      getAllCountriesListRes: payload,
      getAllCountriesListError: null,
    },
  };
};
const handleGetAllCountriesListError = (state, payload) => ({
  ...state,
  ...{
    getAllCountriesListPending: false,
    getAllCountriesListRes: null,
    getAllCountriesListError: payload,
  },
});

/* Get All State From Country List Reducers */
const handleGetAllStateFromCountryListRequest = state => {
  return {
    ...state,
    ...{
      getAllStateFromCountryListPending: true,
      getAllStateFromCountryListRes: null,
      getAllStateFromCountryListError: null,
    },
  };
};
const handleGetAllStateFromCountryListSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllStateFromCountryListPending: false,
      getAllStateFromCountryListRes: payload,
      getAllStateFromCountryListError: null,
    },
  };
};
const handleGetAllStateFromCountryListError = (state, payload) => ({
  ...state,
  ...{
    getAllStateFromCountryListPending: false,
    getAllStateFromCountryListRes: null,
    getAllStateFromCountryListError: payload,
  },
});


/* Get City List From State Reducers*/
const handleGetCityListFromStateRequest = state => {
  return {
    ...state,
    ...{
      getCityListFromStatePending: true,
      getCityListFromStateRes: null,
      getCityListFromStateError: null,
    },
  };
};
const handleGetCityListFromStateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getCityListFromStatePending: false,
      getCityListFromStateRes: payload,
      getCityListFromStateError: null,
    },
  };
};
const handleGetCityListFromStateError = (state, payload) => ({
  ...state,
  ...{
    getCityListFromStatePending: false,
    getCityListFromStateRes: null,
    getCityListFromStateError: payload,
  },
});


/* Add Employee Location Reducers*/
const handleAddEmployeeLocationRequest = state => {
  return {
    ...state,
    ...{
      addEmployeeLocationPending: true,
      addEmployeeLocationRes: null,
      addEmployeeLocationError: null,
    },
  };
};
const handleAddEmployeeLocationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addEmployeeLocationPending: false,
      addEmployeeLocationRes: payload,
      addEmployeeLocationError: null,
    },
  };
};
const handleAddEmployeeLocationError = (state, payload) => ({
  ...state,
  ...{
    addEmployeeLocationPending: false,
    addEmployeeLocationRes: null,
    addEmployeeLocationError: payload,
  },
});

/* Get Employee Location Reducers*/
const handleGetEmployeeLocationRequest = state => {
  return {
    ...state,
    ...{
      getEmployeeLocationPending: true,
      getEmployeeLocationRes: null,
      getEmployeeLocationError: null,
    },
  };
};
const handleGetEmployeeLocationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getEmployeeLocationPending: false,
      getEmployeeLocationRes: payload,
      getEmployeeLocationError: null,
    },
  };
};
const handleGetEmployeeLocationError = (state, payload) => ({
  ...state,
  ...{
    getEmployeeLocationPending: false,
    getEmployeeLocationRes: null,
    getEmployeeLocationError: payload,
  },
});

/* Get Employee Location Reducers*/
const handleUpdateMultipleEmployeeLocationRequest = state => {
  return {
    ...state,
    ...{
      updateMultipleEmployeeLocationPending: true,
      updateMultipleEmployeeLocationRes: null,
      updateMultipleEmployeeLocationError: null,
    },
  };
};
const handleUpdateMultipleEmployeeLocationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateMultipleEmployeeLocationPending: false,
      updateMultipleEmployeeLocationRes: payload,
      updateMultipleEmployeeLocationError: null,
    },
  };
};
const handleUpdateMultipleEmployeeLocationError = (state, payload) => ({
  ...state,
  ...{
    updateMultipleEmployeeLocationPending: false,
    updateMultipleEmployeeLocationRes: null,
    updateMultipleEmployeeLocationError: payload,
  },
});

/* Get All City Reducers*/
const handleGetAllCityRequest = state => {
  return {
    ...state,
    ...{
      getAllCityPending: true,
      getAllCityRes: null,
      getAllCityError: null,
    },
  };
};
const handleGetAllCitySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllCityPending: false,
      getAllCityRes: payload,
      getAllCityError: null,
    },
  };
};
const handleGetAllCityError = (state, payload) => ({
  ...state,
  ...{
    getAllCityPending: false,
    getAllCityRes: null,
    getAllCityError: payload,
  },
});


/* Get All City From Country Reducers*/
const handleGetAllCityFromCountryRequest = state => {
  return {
    ...state,
    ...{
      getAllCityFromCountryPending: true,
      getAllCityFromCountryRes: null,
      getAllCityFromCountryError: null,
    },
  };
};
const handleGetAllCityFromCountrySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllCityFromCountryPending: false,
      getAllCityFromCountryRes: payload,
      getAllCityFromCountryError: null,
    },
  };
};
const handleGetAllCityFromCountryError = (state, payload) => ({
  ...state,
  ...{
    getAllCityFromCountryPending: false,
    getAllCityFromCountryRes: null,
    getAllCityFromCountryError: payload,
  },
});


/* Get Location By Let Log Reducers*/
const handleGetLocationByLetLogRequest = state => {
  return {
    ...state,
    ...{
      getLocationByLetLogPending: true,
      getLocationByLetLogRes: null,
      getLocationByLetLogError: null,
    },
  };
};
const handleGetLocationByLetLogSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getLocationByLetLogPending: false,
      getLocationByLetLogRes: payload,
      getLocationByLetLogError: null,
    },
  };
};
const handleGetLocationByLetLogError = (state, payload) => ({
  ...state,
  ...{
    getLocationByLetLogPending: false,
    getLocationByLetLogRes: null,
    getLocationByLetLogError: payload,
  },
});



/* Clear Location Store Reducers */
const clearLocationStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CREATE_LOCATION_STORE':
      return {
        ...state,
        ...{
          createLocationPending: false,
          createLocationRes: null,
          createLocationError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_LOCATION_STORE':
      return {
        ...state,
        ...{
          updateLocationPending: false,
          updateLocationRes: null,
          updateLocationError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_LOCATION_STORE':
      return {
        ...state,
        ...{
          deleteLocationPending: false,
          deleteLocationRes: null,
          deleteLocationError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_ALL_STATE_FROM_COUNTRY_LIST_STORE':
      return {
        ...state,
        ...{
          getAllStateFromCountryListPending: false,
          getAllStateFromCountryListRes: null,
          getAllStateFromCountryListError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_CITY_LIST_FROM_STATE_STORE':
      return {
        ...state,
        ...{
          getCityListFromStatePending: false,
          getCityListFromStateRes: null,
          getCityListFromStateError: null,
        },
      };
    case 'HANDLE_ADD_EMPLOYEE_LOCATION_STATE_STORE':
      return {
        ...state,
        ...{
          addEmployeeLocationPending: false,
          addEmployeeLocationRes: null,
          addEmployeeLocationError: null,
        },
      };
    case 'HANDLE_UPDATE_MULTIPLE_EMPLOYEE_LOCATION_STORE':
      return {
        ...state,
        ...{
          updateMultipleEmployeeLocationPending: false,
          updateMultipleEmployeeLocationRes: null,
          updateMultipleEmployeeLocationError: null,
        },
      };
    default:
      return state;
  }
};

export default createReducer(
  {
    [actions.getAllLocationsRequest]: handleGetAllLocationsRequest,
    [actions.getAllLocationsSuccess]: handleGetAllLocationsSuccess,
    [actions.getAllLocationsError]: handleGetAllLocationsError,

    [actions.createLocationRequest]: handleCreateLocationRequest,
    [actions.createLocationSuccess]: handleCreateLocationSuccess,
    [actions.createLocationError]: handleCreateLocationError,

    [actions.updateLocationRequest]: handleUpdateLocationRequest,
    [actions.updateLocationSuccess]: handleUpdateLocationSuccess,
    [actions.updateLocationError]: handleUpdateLocationError,

    [actions.deleteLocationRequest]: handleDeleteLocationRequest,
    [actions.deleteLocationSuccess]: handleDeleteLocationSuccess,
    [actions.deleteLocationError]: handleDeleteLocationError,

    [actions.getAllLocationsDataRequest]: handleGetAllLocationsDataRequest,
    [actions.getAllLocationsDataSuccess]: handleGetAllLocationsDataSuccess,
    [actions.getAllLocationsDataError]: handleGetAllLocationsDataError,

    [actions.getAllCountriesListRequest]: handleGetAllCountriesListRequest,
    [actions.getAllCountriesListSuccess]: handleGetAllCountriesListSuccess,
    [actions.getAllCountriesListError]: handleGetAllCountriesListError,

    [actions.getAllStateFromCountryListRequest]: handleGetAllStateFromCountryListRequest,
    [actions.getAllStateFromCountryListSuccess]: handleGetAllStateFromCountryListSuccess,
    [actions.getAllStateFromCountryListError]: handleGetAllStateFromCountryListError,

    [actions.getCityListFromStateRequest]: handleGetCityListFromStateRequest,
    [actions.getCityListFromStateSuccess]: handleGetCityListFromStateSuccess,
    [actions.getCityListFromStateError]: handleGetCityListFromStateError,

    [actions.addEmployeeLocationRequest]: handleAddEmployeeLocationRequest,
    [actions.addEmployeeLocationSuccess]: handleAddEmployeeLocationSuccess,
    [actions.addEmployeeLocationError]: handleAddEmployeeLocationError,

    [actions.getEmployeeLocationRequest]: handleGetEmployeeLocationRequest,
    [actions.getEmployeeLocationSuccess]: handleGetEmployeeLocationSuccess,
    [actions.getEmployeeLocationError]: handleGetEmployeeLocationError,

    [actions.updateMultipleEmployeeLocationRequest]: handleUpdateMultipleEmployeeLocationRequest,
    [actions.updateMultipleEmployeeLocationSuccess]: handleUpdateMultipleEmployeeLocationSuccess,
    [actions.updateMultipleEmployeeLocationError]: handleUpdateMultipleEmployeeLocationError,

    [actions.getAllCityRequest]: handleGetAllCityRequest,
    [actions.getAllCitySuccess]: handleGetAllCitySuccess,
    [actions.getAllCityError]: handleGetAllCityError,

    [actions.getAllCityFromCountryRequest]: handleGetAllCityFromCountryRequest,
    [actions.getAllCityFromCountrySuccess]: handleGetAllCityFromCountrySuccess,
    [actions.getAllCityFromCountryError]: handleGetAllCityFromCountryError,

    [actions.getLocationByLetLogRequest]: handleGetLocationByLetLogRequest,
    [actions.getLocationByLetLogSuccess]: handleGetLocationByLetLogSuccess,
    [actions.getLocationByLetLogError]: handleGetLocationByLetLogError,

    [actions.handleClearLocationStore]: clearLocationStore,

  },
  initialState,
);